import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';

// Import styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import modules
import { Pagination, Navigation } from 'swiper/modules';
import { useEffect, useRef, useState } from 'react';

// Estilo compartido para los botones de navegación
const navButtonStyle = {
    width: 23,
    height: 23,
    borderRadius: '50%',
    border: '1px solid #e0e0e0',
    background: '#f5f5f5', // gris claro
    color: '#444',         // gris oscuro para el icono
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 20,
    cursor: 'pointer',
    flex: '0 0 auto'
};

// Componente wrapper que controla el slider
const SwipperSliderProductos = ({ productos }) => {

    const [swiperInstance, setSwiperInstance] = useState(null);

    const handlePrev = () => {
        if (swiperInstance) swiperInstance.slidePrev();
    };
    const handleNext = () => {
        if (swiperInstance) swiperInstance.slideNext();
    };

    return (

        <div style={{ display: "flex", alignItems: "center", gap:"8px", justifyContent:"space-between" }}>
            <button
                onClick={handlePrev}
                style={navButtonStyle}
                aria-label="Anterior"
            >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M11.5 14L7.5 9L11.5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
            <div style={{width:"85%"}}>
                <ProductSwiperSlider
                    productos={productos}
                    onPrevious={() => { }}
                    onNext={() => { }}
                    setSwiperInstance={setSwiperInstance}
                    hideDefaultNav={true}
                />
            </div>
            <button
                onClick={handleNext}
                style={navButtonStyle}
                aria-label="Siguiente"
            >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M6.5 4L10.5 9L6.5 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>

        </div>
    );
};

const ProductSwiperSlider = ({ productos, setSwiperInstance }) => {
    const swiperRef = useRef(null);

    useEffect(() => {
        if (swiperRef.current && swiperRef.current.swiper && setSwiperInstance) {
            setSwiperInstance(swiperRef.current.swiper);
        }
    }, [setSwiperInstance]);


    return (
        <>
            <div className="swiper-custom-nav-wrapper">
                <Swiper
                    ref={swiperRef}
                    spaceBetween={18}
                    breakpoints={Breakpoints}
                    navigation={false}
                    modules={[Pagination, Navigation]}
                >
                    {
                        productos.map((producto, index) => (
                            <SwiperSlide key={index}>
                                <Link
                                    to={`/precios_stock_detallado/${producto.Codigo}`}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '14px',
                                        padding: '18px',
                                        background: 'transparent',
                                        boxSizing: 'border-box',
                                        height: '110px',
                                        gap: '18px',
                                        cursor: 'pointer',
                                        textDecoration: 'none',
                                        color: 'inherit',
                                        margin: '5px'
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '70px',
                                            height: '70px',
                                            flexShrink: 0,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            background: 'transparent',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <img
                                            src={producto.Imagen}
                                            alt={producto.Nombre}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain',
                                                display: 'block'
                                            }}
                                        />
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ color: 'rgb(31, 31, 31)', fontSize: 12, wordBreak: 'break-word' }}>
                                            {producto.Descripcion && producto.Descripcion.length > 40
                                                ? producto.Descripcion.slice(0, 39) + '...'
                                                : producto.Descripcion}
                                        </div>
                                    </div>
                                </Link>
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
            </div>
        </>
    )
}

const Breakpoints = {
    320: {
        slidesPerView: 1
    },
    1000: {
        slidesPerView: 2
    },
}

export default SwipperSliderProductos;

